<template>
    <section class="chart-levels">
        <section class="emotion-level">
            <h5 class="chart-title">
                Emotion Level Count
            </h5>

            <ReportStackChart
                class="chart"
                :labels="this.emotionLevelLabels"
                :data="emotionLevelCount"
                :width="600"
                :height="300"
                type="horizontalBar"
            />
        </section>

        <section class="stress-level">
            <h5 class="chart-title">
                Stress Level Count
            </h5>

            <ReportStackChart
                class="chart"
                :labels="this.stressLevelLabels"
                :data="stressLevelCount"
            />
        </section>
    </section>
</template>

<script>
import ReportStackChart from '@/components/user-profile/ReportStackChart.vue'

export default {
	props: {
		reportData: {
			required: true
		}
	},

	data () {
		return {
			emotionLevelLabels: [
				'Excitement', 'Happy', 'Zen', 'Pleasant',
				'Calm', 'Loading', 'Unpleasant', 'Confused',
				'Challenged', 'Hyped', 'Sad', 'Anxious'
			],

			stressLevelLabels: ['Low', 'Mild', 'Moderate', 'Severe']
		}
	},

	computed: {
		emotionLevelCount () {
			return this.emotionLevelLabels.reduce((result, item) => {
				const emotionCount = this.reportData.emotion_count[item]

				result.push(emotionCount)
				return result
			}, [])
		},

		stressLevelCount () {
			return this.stressLevelLabels.reduce((result, item) => {
				const emotionCount = this.reportData.stress_level_count[item]

				result.push(emotionCount)
				return result
			}, [])
		}
	},

	components: {
		ReportStackChart
	}
}
</script>

<style lang="scss" scoped>
.chart-levels {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    padding-top: 15px;
    border-top: 1px solid #dadada;
    margin-bottom: 5px;

    .emotion-level, .stress-level {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
    }

    .chart-title {
        margin-bottom: 15px;
        font-weight: 600;
        padding-left: 15px;
        font-size: 13px;
    }

    .emotion-level {
        width: 67%;
    }

    .stress-level {
        width: 33%;
    }
}
</style>
